import { action } from 'mobx';
import { getPrivateActionType, getPrivateActionId } from './actionCreator';
import { subscribe } from './dispatcher';
import { getGlobalContext } from './globalContext';
export default function mutator(actionCreator, target) {
    var actionId = getPrivateActionId(actionCreator);
    if (!actionId) {
        throw new Error('Mutators can only subscribe to action creators.');
    }
    var actionType = getPrivateActionType(actionCreator);
    var wrappedTarget = action(actionType, function (actionMessage) {
        var globalContext = getGlobalContext();
        try {
            globalContext.currentMutator = actionType;
            target(actionMessage);
            globalContext.currentMutator = null;
        }
        catch (e) {
            globalContext.currentMutator = null;
            throw e;
        }
    });
    subscribe(actionId, wrappedTarget);
    return target;
}
